// extracted by mini-css-extract-plugin
module.exports = {"videoWrapper":"Tutorial_videoWrapper__1eX5m"};